/** After first paint / LCP — do not start optional downloads in useEffect. */
export function whenBrowserIdle(callback: () => void): () => void {
  const events = ["scroll", "pointerdown", "touchstart", "keydown"] as const;
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    cleanup();
    callback();
  };
  const cleanup = () => {
    for (const event of events) {
      window.removeEventListener(event, run);
    }
    window.clearTimeout(timer);
  };
  for (const event of events) {
    window.addEventListener(event, run, { once: true, passive: true });
  }
  const timer = window.setTimeout(run, 4000);
  return cleanup;
}
